import React, { useState } from 'react';
import './FAQs.css';

// SVG Icon Components
const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path d="M7.25922 19.2956L5.84802 17.8844L11.4928 12.2396L5.84802 6.59479L7.25922 5.18359L12.904 10.8284L18.5488 5.18359L19.96 6.59479L14.3152 12.2396L19.96 17.8844L18.5488 19.2956L12.904 13.6508L7.25922 19.2956Z" fill="#161616"/>
  </svg>
);

const PlusIcon = () => ( // Placeholder for Plus Icon - using a simple cross for now
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
    <path d="M11.626 14.2721H6.07031V11.7281H11.626V6.17236H14.17V11.7281H19.7257V14.2721H14.17V19.8279H11.626V14.2721Z" />
  </svg>
);

const FAQ_DATA = [
  {
    question: 'What is One-Time Fantasy?',
    answer: 'One-Time Fantasy is a platform where you can draft a team of professional poker players competing in real-life tournaments. Your team earns points based on their performance, and you compete against other users for prizes.'
  },
  {
    question: 'How do I draft a team?',
    answer: 'Once a contest is open, you can enter and select players from the available roster of poker pros participating in the specified tournament. Each player may have a different salary cap, and you\'ll need to build your team within the total salary limit.'
  },
  {
    question: 'How is scoring calculated?',
    answer: 'Points are typically awarded based on a player\'s finishing position in the tournament. Additional points might be awarded for specific achievements, like eliminating another player or reaching the final table. The exact scoring rules are detailed in each contest\'s information page.'
  },
  {
    question: 'Are there different types of contests?',
    answer: 'Yes, we offer various contest formats, including contests for different poker tournaments (e.g., WSOP, WPT), different entry fees, and different prize structures. Check the "Contests" page for all currently available options.'
  },
  {
    question: 'Can I change my lineup after a contest starts?',
    answer: 'No, once a contest locks (usually when the real-life poker tournament begins), lineups cannot be changed. Make sure to finalize your team before the contest start time.'
  }
];

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="homev2-faqs">
      <div className="homev2-faqs__inner-container">
        <div className="homev2-faqs__title-container">
          <h2 className="homev2-faqs__heading">Frequently Asked Questions</h2>
        </div>
        <div className="homev2-faqs__questions-container">
          {FAQ_DATA.map((faq, index) => (
            <div className="homev2-faqs__item" key={index}>
              <div className="homev2-faqs__item-header" onClick={() => toggleFAQ(index)}>
                <p className="homev2-faqs__item-question-text">{faq.question}</p>
                <span className="homev2-faqs__item-icon">
                  {openIndex === index ? <CloseIcon /> : <PlusIcon />}
                </span>
              </div>
              {openIndex === index && (
                <p className="homev2-faqs__item-answer">
                  {faq.answer}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQs; 